import axios from '@/libs/api.request'

export const getTrackList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/track'
  })
}

export const getTrackPlayList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/track/play'
  })
}

export const addTrack = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/track'
  })
}

export const editTrack = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/track'
  })
}

export const delTrack = (id) => {
  return axios.request({
    method: 'delete',
    url: '/track/' + id
  })
}

export const changeStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/track/status/' + id
  })
}
